import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import Midstock, { MidstockListState } from "common-ts/dist/models/Midstock";

const initialState : MidstockListState = {
    midstockList: [],
    clothInventoryList: [],

    status: APIRequestStatus.Idle,
    error: null
}

export const fetchClothInventory = createAsyncThunk('midstockList/fetchClothInventory', async () => {
    const response = await axios({
        method: 'get',
        url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock?isproductionview=true',
    });
    return response.data
})

export const fetchMidstockList = createAsyncThunk('midstockList/fetchMidstockList', async () => {
    const response = await axios({
        method: 'get',
        url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/midstock',
    });
    return response.data
})

export const slice = createSlice({
    name: 'midstockList',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
      builder
        .addCase(fetchMidstockList.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(fetchMidstockList.fulfilled, (state, action) => {
            state.midstockList = action.payload.midstockList
            .map((midstockItem: Midstock) => {
                if (midstockItem?.stockFinishProcessesData?.length) {
                    return midstockItem;
                } else {
                    return {
                        ...midstockItem,
                        stockFinishProcessesData: [
                            {
                                "maxPeople": 1,
                                "processName": "Jahit",
                                "processPoints": midstockItem.stockFinishPointsAwarded,
                                "timeSpent": 1
                            },
                            {
                                "maxPeople": 1,
                                "processName": "QC Stok Kerah",
                                "processPoints": 0.5, // Now 0.5 points each
                                "timeSpent": 1
                            },
                        ]
                    }
                }
            });

            state.status = APIRequestStatus.Success;
        })
        .addCase(fetchMidstockList.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            // state.error = action.error.message
            console.log("fetch is failure");
        })
        .addCase(fetchClothInventory.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(fetchClothInventory.fulfilled, (state, action) => {
            state.clothInventoryList = action.payload.clothInventoryList;

            state.status = APIRequestStatus.Success;
        })
        .addCase(fetchClothInventory.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            // state.error = action.error.message
            console.log("fetch is failure");
        })
    }
})

export default slice.reducer